<div class="row">
    <div class="col-12">
        <div class="m-l-20 table-matrix">
            <table class="table table-hover">
                <tr>
                    <th class="font-weight-bold">{{table.category}}</th>
                    <th>{{table.header.value}}</th>
                    <th *ngFor="let period of table.header.previousPeriods">{{period}}</th>
                </tr>
                <tr *ngFor="let row of table.body.rows">
                    <td>{{row.category}}</td>
                    <td>
                        <div *ngFor="let scorePoint of row.scorePoints">
                            <span [ngClass]="[row.type + '-color']">{{scorePoint.title}}</span>
                            <span class="result-matrix">{{scorePoint.votes}}</span>
                        </div>
                    </td>
                    <td *ngFor="let scorePoints of row.previousPeriodValues">
                        <div *ngFor="let scorePoint of scorePoints">
                            <span>{{scorePoint.title}}</span><span class="result-matrix">{{scorePoint.votes}}</span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
